import { capacitorAuth } from '../capacitor/auth';
import { User } from '../../types';

const API_URL = import.meta.env.VITE_API_URL;

class SocialAuthAPI {
  private async request(endpoint: string, idToken: string) {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ idToken })
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  async loginWithGoogle(): Promise<User> {
    const idToken = await capacitorAuth.signInWithGoogle();
    return this.request('/api/auth/google', idToken);
  }

  async loginWithApple(): Promise<User> {
    const idToken = await capacitorAuth.signInWithApple();
    return this.request('/api/auth/apple', idToken);
  }
}

export const socialAuthAPI = new SocialAuthAPI();